import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { isItemActive, sortItemsByEndDate } from "../lib/auctions";

export default function ItemsList() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "items"), (snapshot) => {
      const allItems = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const activeItems = allItems.filter((item) => isItemActive(item));
      setItems(sortItemsByEndDate(activeItems));
    });
    return unsub;
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center mb-8">
        Enchères Disponibles
      </h1>
      {items.length === 0 ? (
        <p className="text-center text-gray-600">
          Aucune enchère active pour le moment.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/item/${item.slug}`}
              className="border rounded-lg overflow-hidden hover:shadow-lg"
            >
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-48 object-cover"
                />
              ) : (
                <div className="w-full h-48 bg-orange-100 flex items-center justify-center text-center px-4 text-orange-700 font-semibold">
                  Image à venir
                </div>
              )}
              <div className="p-4">
                <h2 className="font-bold text-xl mb-2">{item.name}</h2>
                <p className="text-gray-700 mb-4 truncate">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
